<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    showSelectedItem: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      searchQuery: '',
      filteredItems: [],
      showDropdown: false,
      selectedItem: null,
      activeIndex: -1
    };
  },

  watch: {
    items: {
      immediate: true,
      handler(newItems) {
        this.filteredItems = this.getSortedItems(newItems);
      }
    }
  },

  methods: {
    getSortedItems(items) {
      return [...items].sort((a, b) =>
          a.nome.toLowerCase().localeCompare(b.nome.toLowerCase())
      );
    },

    handleInput() {
      this.showDropdown = true;
      this.activeIndex = -1;

      if (this.searchQuery.length > 0) {
        const inputWords = this.searchQuery.toLowerCase().split(' ');
        this.filteredItems = this.items.filter(item => {
          const itemWords = item.nome.toLowerCase().split(' ');
          return inputWords.every(inputWord =>
              itemWords.some(itemWord => itemWord.startsWith(inputWord))
          );
        });
      } else {
        this.filteredItems = this.getSortedItems(this.items);
      }

      // Don't close dropdown even if there are no results
      this.showDropdown = true;
    },

    navigateDown() {
      if (this.activeIndex < this.filteredItems.length - 1) {
        this.activeIndex++;
        this.showDropdown = true;
      }
    },

    navigateUp() {
      if (this.activeIndex > 0) {
        this.activeIndex--;
        this.showDropdown = true;
      }
    },

    handleEnter() {
      if (this.filteredItems.length === 1) {
        // If there's exactly one match, select it
        this.selectItem(this.filteredItems[0]);
      } else if (this.activeIndex >= 0 && this.activeIndex < this.filteredItems.length) {
        // If an item is highlighted, select it
        this.selectItem(this.filteredItems[this.activeIndex]);
      }
    },

    selectItem(item) {
      this.selectedItem = item;
      this.searchQuery = '';
      this.showDropdown = false;
      this.activeIndex = -1;
      this.$emit('select', item);
    },

    clearSearch() {
      this.searchQuery = '';
      this.selectedItem = null;
      this.activeIndex = -1;
      this.filteredItems = this.getSortedItems(this.items);
      this.showDropdown = false;
      this.$emit('select', null);
    }
  },

  mounted() {
    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.showDropdown = false;
      }
    });
  },

  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>

<template>
  <div class="dropdown-search">
    <div class="input-group mb-3">
      <input
          v-model="searchQuery"
          @input="handleInput"
          @keydown.down="navigateDown"
          @keydown.up="navigateUp"
          @keydown.enter="handleEnter"
          @focus="showDropdown = true"
          ref="searchInput"
          class="form-control"
          placeholder="Cerca..."
      />
      <div class="input-group-append">
        <button type="button" class="btn btn-outline-secondary" @click="clearSearch">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>

    <div v-show="showDropdown" class="dropdown-menu w-100" :class="{ 'show': showDropdown }">
      <ul v-if="filteredItems.length > 0" class="list-group list-group-flush">
        <li
            v-for="(item, index) in filteredItems"
            :key="item.id"
            @click="selectItem(item)"
            @mouseenter="activeIndex = index"
            class="list-group-item list-group-item-action"
            :class="{ 'active': index === activeIndex }"
        >
          {{ item.nome }}
        </li>
      </ul>
      <div v-else class="no-results p-3 text-center">
        <i class="fas fa-search mb-2"></i>
        <p class="mb-0">Nessuna materia trovata per "{{ searchQuery }}"</p>
      </div>
    </div>

    <!--<div v-if="selectedItem && !showDropdown && showSelectedItem" class="selected-display mt-2">
      <div class="d-flex justify-content-between align-items-center">
        <span>{{ selectedItem.nome }}</span>
        <button
            class="btn btn-link"
            @click="clearSearch"
            title="Mostra la lista completa"
        >
          <i class="fas fa-expand"></i>
        </button>
      </div>
    </div>-->
  </div>
</template>

<style scoped>
.dropdown-search {
  position: relative;
}

.dropdown-menu {
  position: relative;
  max-height: 300px;
  overflow-y: auto;
  margin-top: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.list-group-item-action {
  cursor: pointer;
  padding: 0.5rem 1rem;
  color: #212529;
}

.list-group-item-action:hover,
.list-group-item-action.active {
  background-color: #f8f9fa;
  color: #212529;
}

.selected-display {
  padding: 0.75rem 1.25rem;
  background-color: #fff;
  border: 1px solid rgba(0,0,0,.125);
  border-radius: 0.25rem;
  color: black;
}

.btn-link {
  padding: 0;
  color: #6c757d;
}

.btn-link:hover {
  color: #343a40;
}

.no-results {
  color: white;
}

.no-results i {
  font-size: 1.5rem;
  display: block;
  margin-bottom: 0.25rem;
}

.no-results p {
  font-weight: 500;
}

.form-control{
  caret-color: black;
}
</style>